import axios from 'axios'
import { Message, Loading } from 'element-ui';
let loading;
let loadingNum = 0; //  内存中正在请求的数量
function startLoading() {
	if (loadingNum == 0) {
		loading = Loading.service({
			lock: true,
			text: '拼命加载中...',
			background: 'rgba(255,255,255,0.5)',
			target: document.querySelector('.content,.content1'),
		})
	}
	loadingNum++;
}
function endLoading() { //  关闭加载动画
	loadingNum--;
	if (loadingNum <= 0) {
		loading.close();
	}
}
var baseURL = process.env.API_ROOT;
const service = axios.create({
	baseURL: baseURL,
	responseType: 'json',
	withCredentials: true,
	timeout: 3*60 * 1000
})
service.interceptors.request.use(
	config => {
		// startLoading(); //  打开加载动画
		var token = sessionStorage.getItem('token') || '';
		config.headers = {
			"Authorization": "Bearer "+ token,
			'Accept': 'application/json, text/plain, */*' //配置请求头
		}
		// if(config.method=='get'){
		// 	if(config.params&&config.params.perpage){
		// 		config.params['limit'] = config.params.perpage;
		// 	}
		// }
		// if(config.method=='post'){
		// 	if(config.data&&config.data.perpage){
		// 		config.data['limit'] = config.data.perpage;
		// 	}
		// }
		return config
	}, error => {
		Promise.reject(error)
	}
)

// 3.响应拦截器
service.interceptors.response.use(
	response => {
		// endLoading();
		if(response.config.responseType=='blob'){
			return Promise.resolve(response.data)
		}else{
			if (response.status == 200) {
				if (response.data.code == 0) {
					return Promise.resolve(response.data)
				} else if (response.data.code == -1) {
					return Promise.reject(response.data.msg)
				} else {
					// Message.error(response.data.msg)
					// return Promise.reject('程序错误')
				}
			}
		}
	}, error => {
		//endLoading();
	}
)
export default service



// WEBPACK FOOTER //
// ./src/utils/axios.js